import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-dashboard-react/components/chucnangStyle.js";
const useStyles = makeStyles(styles);
import Config from "conFig.js";

const Phuongthucvantai = React.memo(function Phuongthucvantai(props) {
  const { thangnam } = props;
  const classes = useStyles();
  const [phuongthuc, setPhuongthuc] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  const getptvantai = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/DashBoard/dashphuonthucvantai?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPhuongthuc(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tabledb_th}>Phương thức vận tải</th>
          <th className={classes.tabledb_th}>Số lượt (chuyến)</th>
          <th className={classes.tabledb_th}>Số hành khách vận chuyển</th>
          <th className={classes.tabledb_th}>Sản lượng hàng hóa vận chuyển</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {phuongthuc.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tabledb_td}>{row["phuongthuc"]}</td>
              <td className={classes.tabledb_td_number}>
                {Number(row["soluot"]).toLocaleString()}
              </td>
              <td className={classes.tabledb_td_number}>
                {Number(row["sokhachvanchuyen"]).toLocaleString()}
              </td>
              <td className={classes.tabledb_td_number}>
                {Number(row["slhanghoavanchuyen"]).toLocaleString()}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = phuongthuc.length > 0 ? renderTableBody() : null;
  React.useEffect(() => {
    getptvantai();
  }, [thangnam]);
  return (
    <div className={classes.table}>
      <table className={classes.tabledb}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});
Phuongthucvantai.propTypes = {
  thangnam: PropTypes.object,
};
export default Phuongthucvantai;
